export default __webpack_public_path__ + "static/media/closet2-768w.fc87555f.webp";